import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherGetLogisticsCostSaga() {
  yield takeEvery("LOAD_LOGISTICS_COST", workerSaga);
  console.log("Called Here 0444");
}

function* workerSaga(action) {
  try {
    console.log("Called Here 0888");

    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};

    var formatUrl = `get-logistics-costs`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOGISTICS_COST_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("Logistics-Cost", e);
    console.log("Logistics-Cost-Error", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
